import React from 'react';
import Q2Conclusion from './Q2Conclusion';
import Q2Header from './Q2Header';
import Q2Row1 from './Q2Row1';
import Q2Row2 from './Q2Row2';

function StoryQ2() {
  return (
    <>
      <Q2Header />
      <Q2Row1 />
      <div className="pagebreak80" />
      <Q2Row2 />
      <Q2Conclusion />
    </>
  );
}

export default StoryQ2;
